import { a } from "react-router-dom";

export default function OpenPopup({ OpenNext, setOpenNext, DeleteData }) {
  const handleCancel1 = () => {
    setOpenNext(false);
  };

//   const handleDelete = () => {
//     DeleteData?.Delete();
//     setOpenNext(false);
//   };

  return (
    <div
      id="CreatContact"
      className={OpenNext ? "overlay-note w-100" : "overlay-note"}
      style={{ top: "10%", zIndex: "928832474647" }}
    >
      <div className="overlay-note-content mblVwe">
        <div className="note-title">
          <h4 className="text-left text-white pl-3">Confirmation</h4>
          <div className="closebtn">
            {/* <a id="hide-note-max" className="text-right text-white">
              <i className="fas fa-minus"></i>
            </a> */}
            <a
              className="text-right text-white"
              onClick={() => setOpenNext(false)}
            >
              <i className="fas fa-times"></i>
            </a>
          </div>
        </div>
        <div
          style={{ padding: "20px" }}
          className="Send_Email_Form"
          id="noteBody"
        >
          <div
            style={{
              display: "flex",
              flexDirection:"column",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div>
              {" "}
              <p style={{ fontWeight: "bold" }}>{DeleteData?.msg} </p>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
              }}
            >
              {/* <button className="cst_btn" onClick={() => handleDelete()}>
                Yes
              </button>{" "} */}
              <button className="cst_btn" onClick={() => handleCancel1()}>
                Close
              </button>{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
